import React from 'react'
import { Button, Grid } from '@mui/material'
import ReactModal from 'react-modal'
import { useTranslation } from 'react-i18next'
import { useAppNavigate, useAppType } from '../../../../context/AppContext'
import SushiLogo from '../../../../assets/images/logo_bg.png'
import CateringLogo from '../../../../assets/images/panda-catering-logo-no-bg.png'
import { IGeneralInfo } from '../../../../types/app'
import './SuccessModal.scss'
import { getStorageKey } from '../../../../utils/appType'

type Props = {
  isOpen: boolean
  setIsOpen?: (isOpen: boolean) => void
  generalInfo: IGeneralInfo
  orderPrice: number
}
const c = 'success-modal'

const SuccessModal = (props: Props) => {
  const { t } = useTranslation()
  const navigate = useAppNavigate()
  const appType = useAppType()
  const Logo = appType === 'catering' ? CateringLogo : SushiLogo

  const roulettePrize = localStorage.getItem(getStorageKey('roulettePrize'))

  return (
    <ReactModal
      shouldCloseOnOverlayClick
      className='success-modal-container'
      isOpen={props.isOpen}
      onRequestClose={() => {
        localStorage.removeItem(getStorageKey('pendingOrderSuccess'))
        sessionStorage.removeItem('orderCompleted')
        localStorage.removeItem(getStorageKey('rouletteWinningPrize'))
        localStorage.removeItem(getStorageKey('roulettePrize'))
        localStorage.removeItem(getStorageKey('successMessage'))
        props.setIsOpen?.(false)
        navigate('/')
      }}
    >
      <div className={c}>
        <div className={`${c}-header`}>
          <div className={`${c}__header-image`}>
            <img src={Logo} alt='logo' height={100} width={100} />
          </div>
        </div>
        <div className={`${c}__content`}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <div className={`${c}__content-text`}>
                {t('OPERATOR_CALL_SOON')}
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className={`${c}__content-text`}>
                {t('THANKS_FOR_ORDER')}☀️
              </div>
            </Grid>
            {roulettePrize && (
              <Grid item xs={12}>
                <div
                  className={`${c}__content-text`}
                  style={{ color: 'var(--color-primary)', fontWeight: 'bold' }}
                >
                  🎉 {t('YOU_WON')}: {roulettePrize}! 🎉
                </div>
              </Grid>
            )}
          </Grid>
          <div className={`${c}__content-submit`}>
            <Button
              variant='contained'
              onClick={() => {
                localStorage.removeItem(getStorageKey('pendingOrderSuccess'))
                sessionStorage.removeItem('orderCompleted')
                localStorage.removeItem(getStorageKey('rouletteWinningPrize'))
                localStorage.removeItem(getStorageKey('roulettePrize'))
                localStorage.removeItem(getStorageKey('successMessage'))
                navigate('/')
                props.setIsOpen?.(false)
              }}
              sx={{
                backgroundColor: 'var(--color-primary)',
                textTransform: 'none',
                fontWeight: 'bold',
                width: '100%',
                '&:hover': { backgroundColor: 'var(--color-primary-hover)' },
              }}
            >
              {t('CLOSE')}
            </Button>
          </div>
        </div>
      </div>
    </ReactModal>
  )
}

export default SuccessModal
